/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/sort-comp */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {FmlxButton, FmlxIcon} from 'fmlx-common-ui';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import {SetCustomOperationRepeatedValue, SetCustomOperationRepeatValue} from '@/actions/setupActions';
import {Get, Post} from '@/api/request';
import HelpIcon from '@/assets/icons/Question.svg';
import ERROR_FILE_ICON from '@/assets/icons/si-glyph-document-error-grey.svg';
import {setFavoriteManualProfile, fetchListManualProfiles} from '@/businesses/manualProfileBusiness';
import PopUpWizard from '@/components/popup/PopUpWizard';
import * as APPDATA from '@/constants/pcConstAppData';

import {SEQUENCE_TYPE, RUN_TIME_MODE, SEQUENCE_TYPE_ALL_ENUM} from '../constant/sequenceContentConstants';
import {DataHelp} from '../help/ManualProfileHelp';

import ManualProfileSequence from './ManualProfileSequence';

import './ManualProfileExplorer.less';

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  CustomOperation: store.setupStore.CustomOperation,
}))
class ManualProfileExplorer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHelpModeEnable: false,
      selectedSequenceDetail: null,
      listSequenceFile: null,
      searchManualProfile: null,
    };
    this.successRenameSequence = this.successRenameSequence.bind(this);
    this.updateListSequence = this.updateListSequence.bind(this);
    this.successGetDetailSequence = this.successGetDetailSequence.bind(this);
    this.successSearchSequence = this.successSearchSequence.bind(this);
    this.successDeleteSequence = this.successDeleteSequence.bind(this);
    this.successGetListSequence = this.successGetListSequence.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.MANUAL_PROFILE_EXPLORER));
    this.setupTopMenuProperties(true, true);
    this.getListManualprofile();
  }

  getListManualprofile = async () => {
    const listManualProfiles = await fetchListManualProfiles();
    this.successGetListSequence(listManualProfiles);
  };

  successGetListSequence = (response) => {
    const sequencesFile = response?.data?.map((x) => ({
      active: false,
      name: x.FileName.replace('.json', ''),
      fileName: x.FileName,
      isPreloaded: x.IsPreloaded,
      isFavorite: x.IsFavorite,
    }));
    this.setState({
      listSequenceFile: sequencesFile,
    });
  };

  onClickHelp = () => {
    this.setState({
      isHelpModeEnable: true,
    });
  };

  onClosePopUpWizard = () => {
    this.setState({
      isHelpModeEnable: false,
    });
  };

  setupTopMenuProperties = (deleteButtonDisable, openButtonDisable) => {
    const button1Properties = {
      id: APPDATA.DELETE,
      label: APPDATA.DELETE,
      onClick: this.onClickDeleteSequence,
      disabled: deleteButtonDisable,
      className: ' delete-button ', // not-visibile-div
    };
    const button2Properties = {
      id: APPDATA.OPEN,
      label: APPDATA.OPEN,
      onClick: this.onClickSelectedSequence,
      disabled: openButtonDisable,
      className: ' save-button ',
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.goToHomeScreen,
      // onClick: this.backAction,
    };
    const titleMenuProperties = APPDATA.MANUAL_PROFILE_EXPLORER;
    const secondaryButton = {
      id: 'ManualProfileHelp',
      onClick: this.onClickHelp,
      className: ' helpButtonStyle help-icon',
      icon: HelpIcon,
      disabled: false,
    };
    this.setDoubleTopMenuProperties(
      button1Properties,
      button2Properties,
      backButtonProperties,
      titleMenuProperties,
      secondaryButton,
    );
  };

  setDoubleTopMenuProperties = (
    button1Properties,
    button2Properties,
    backButtonProperties,
    titleMenuProperties,
    calibrationHistoryButton,
  ) => {
    this.props.dispatch(
      setupActions.setDoubleTopMenuProperties({
        button1Properties:
          button1Properties === undefined
            ? undefined
            : {
                id: button1Properties.id,
                label: button1Properties.label,
                onClick: button1Properties.onClick,
                disabled: button1Properties.disabled,
                className: button1Properties.className,
              },
        button2Properties:
          button2Properties === undefined
            ? undefined
            : {
                id: button2Properties.id,
                label: button2Properties.label,
                onClick: button2Properties.onClick,
                disabled: button2Properties.disabled,
                className: button2Properties.className,
              },
        backButtonProperties: {
          id: backButtonProperties.id,
          label: '',
          disabled: backButtonProperties.disabled,
          onClick: backButtonProperties.onClick,
        },
        titleMenuProperties,
        topButtonSecondaryButtonProperties: calibrationHistoryButton,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  onClickSelectedSequence = () => {
    this.props.dispatch(setupActions.SetCustomOperationFileName(this.state.selectedSequenceDetail.FileName));
    this.props.dispatch(setupActions.SetCustomOperationRepeatValue(this.state.selectedSequenceDetail.Repeat));
    this.props.dispatch(setupActions.SetCustomOperationPreloaded(this.state.selectedSequenceDetail.IsPreloaded));
    this.props.dispatch(setupActions.UpdateOperationList(this.state.selectedSequenceDetail.Operations));
    this.props.dispatch(setupActions.SetCustomOperationContentChanged(false));
    window.location.href = APPDATA.MANUAL_PROFILE_ADDRESS;
  };

  onClickFavoriteSequence = async (e) => {
    const data = {FileName: e.FileName, IsFavorite: !e.IsFavorite};
    const response = await setFavoriteManualProfile(data);
    if (response.data) {
      if (this.state.searchManualProfile !== null) {
        this.searchProfileSequence({value: this.state.searchManualProfile});
      } else {
        await this.getListManualprofile();
      }
      this.setState((prevState) => {
        const updatedList = prevState.listSequenceFile
          ? prevState.listSequenceFile.map((seq) =>
              seq.fileName === response.data.FileName ? {...seq, active: true} : {...seq, active: false},
            )
          : prevState.listSequenceFile;

        const updatedSelected =
          prevState.selectedSequenceDetail && prevState.selectedSequenceDetail.FileName === response.data.FileName
            ? {...prevState.selectedSequenceDetail, IsFavorite: response.data.IsFavorite}
            : prevState.selectedSequenceDetail;

        return {
          listSequenceFile: updatedList,
          selectedSequenceDetail: updatedSelected,
        };
      });
    }
  };

  actionRenameSequenceFile = () => {
    this.props.dispatch(
      modalActions.showKeyboard({
        keyboardValue: this.state.selectedSequenceDetail.FileName,
        keyboardTitle: APPDATA.SAVE_MANUAL_PROFILE_AS,
        keyboardCallBack: this.onChangeSetupName,
        keyboardPlaceholder: APPDATA.SAVE_MANUAL_PROFILE_AS,
        overwriteFirstInput: false,
        max: 100,
      }),
    );
  };

  onChangeSetupName = (e) => {
    const stringRegex = /[ `!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/;

    if (stringRegex.test(e.value)) {
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.MANUAL_PROFILE.FIELD_ERROR.FILE_NAME_CONTAIN_SYMBOLS,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
    } else if (e.value === '' || e.value === undefined) {
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.MANUAL_PROFILE.FIELD_ERROR.FILE_NAME_CANNOT_BE_EMPTY,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
    } else if (this.state.selectedSequenceDetail.FileName !== e.value) {
      const sequenceFiles = this.state.listSequenceFile;
      if (sequenceFiles.some((sequence) => sequence.name === e.value && sequence.active === false)) {
        this.props.dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: APPDATA.MESSAGES.MANUAL_PROFILE.FIELD_ERROR.FILE_NAME_USED,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
      } else {
        const name = e.value;
        this.renameSequenceToBackend(name);
      }
    }
  };

  renameSequenceToBackend = (fileName) => {
    const sequenceParam = {
      fileName: this.state.selectedSequenceDetail.FileName,
      newFileName: fileName,
    };
    Post(APPDATA.API.POST_RENAME_SEQUENCE, sequenceParam, this.successRenameSequence, sequenceParam);
  };

  successRenameSequence = async (response, passingVariabel) => {
    const fileName = `${passingVariabel.newFileName}.json`;
    const param = {fileName};
    const passingValue = {fileName};

    await this.getListManualprofile();

    this.setState((prevState) => {
      const updatedList = prevState.listSequenceFile
        ? prevState.listSequenceFile.map((seq) =>
            seq.fileName === passingVariabel.newFileName ? {...seq, active: true} : {...seq, active: false},
          )
        : prevState.listSequenceFile;

      return {
        listSequenceFile: updatedList,
      };
    });
    Post(APPDATA.API.POST_DETAIL_SEQUENCE, param, this.successGetDetailSequence, passingValue);
  };

  updateListSequence = (response, passingVariabel) => {
    const sequencesFile = response.data.map((x) => ({
      active: passingVariabel.fileName === x,
      name: x.replace('.json', ''),
      fileName: x,
    }));
    this.setState({
      listSequenceFile: sequencesFile,
    });
  };

  actionSearchSequenceFile = () => {
    this.props.dispatch(
      modalActions.showKeyboard({
        keyboardValue: '',
        keyboardTitle: 'Search Manual Profile',
        keyboardCallBack: this.searchProfileSequence,
        keyboardPlaceholder: 'Search Manual Profile',
        overwriteFirstInput: true,
        max: 100,
      }),
    );
  };

  searchProfileSequence = (e) => {
    const stringRegex = /[ `!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/;

    if (stringRegex.test(e.value)) {
      this.props.dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.ADV_SETUP.FIELD_ERROR.FILE_NAME_CONTAIN_SYMBOLS,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
    } else if (e.value === '' || e.value === undefined) {
      this.getListManualprofile();
      this.setState({
        searchManualProfile: '',
      });
    } else {
      const searchName = e.value;
      const param = {};
      const passingValue = {searchName};
      Get(
        `${APPDATA.API.POST_SEARCH_SEQUENCE}?searchName=${searchName}`,
        param,
        this.successSearchSequence,
        passingValue,
      );
    }
  };

  successSearchSequence = (response, passingVariabel) => {
    const sequencesFile = response?.data?.map((x) => ({
      active: false,
      name: x.FileName.replace('.json', ''),
      fileName: x.FileName,
      isPreloaded: x.IsPreloaded,
      isFavorite: x.IsFavorite,
    }));

    this.setState({
      listSequenceFile: sequencesFile,
    });

    this.setState({
      searchManualProfile: passingVariabel.searchName,
    });
  };

  onClickDeleteSequence = () => {
    const maxFileNameLeght = 10;
    let fileName = this.state.selectedSequenceDetail.FileName;
    if (fileName.length > maxFileNameLeght) fileName = `${fileName.substring(0, maxFileNameLeght)}...`;
    const popUpButton = [
      {
        id: APPDATA.YES,
        isPrimaryButton: true,
        onClick: this.onClickPopUpDelete,
        label: APPDATA.YES,
      },
      {
        id: APPDATA.NO,
        isPrimaryButton: false,
        onClick: this.onClickPopUpDelete,
        label: APPDATA.NO,
      },
    ];

    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.DELETE_ADV_SETUP,
        popUpQuestion: APPDATA.MESSAGES.ADV_SETUP.DELETE_ADV_SETUP.replace('<advSetup name>', fileName),
        popUpButton,
      }),
    );
  };

  onClickPopUpDelete = (e) => {
    this.props.dispatch(modalActions.hidePopUp());
    switch (e.currentTarget.id) {
      case APPDATA.YES:
        this.deleteManualProfileSequence();
        break;
      case APPDATA.NO:
        break;
      default:
        break;
    }
  };

  deleteManualProfileSequence = () => {
    const fileName = this.state.selectedSequenceDetail.FileName;
    const param = {fileName};
    const passingValue = {};
    Post(APPDATA.API.POST_DELETE_SEQUENCE, param, this.successDeleteSequence, passingValue);
  };

  successDeleteSequence = () => {
    const sequenceFiles = this.state.listSequenceFile;
    sequenceFiles.map((x) => {
      x.active = false;
      return x;
    });
    this.setState({
      selectedSequenceDetail: null,
    });
    this.setupTopMenuProperties(true, true);

    this.getListManualprofile();
    this.clearSequence();
  };

  clearSequence = () => {
    const newOperations = []; // AddSequence([])
    const newRepeatOperations = {
      Repeat: 1,
      Repeated: 0,
    };
    this.props.dispatch(setupActions.SetCustomOperationFileName(null));
    this.props.dispatch(SetCustomOperationRepeatValue(newRepeatOperations.Repeat));
    this.props.dispatch(SetCustomOperationRepeatedValue(newRepeatOperations.Repeated));
    this.props.dispatch(setupActions.UpdateOperationList(newOperations));
    this.props.dispatch(setupActions.SetCustomOperationContentChanged(true));
  };

  goToHomeScreen = () => {
    if (this.state.searchManualProfile === null) window.location.href = APPDATA.MANUAL_PROFILE_ADDRESS;
    else {
      this.getListManualprofile();
      this.setState({
        searchManualProfile: null,
      });
    }
  };

  generateListSequence(listSequenceFile) {
    if (listSequenceFile === null || listSequenceFile === undefined || listSequenceFile === false) return null;

    const showSequence = listSequenceFile.map((d) => {
      const isActiveClass = d.active ? ' activeAdvSetup' : '';

      return (
        <div
          className={`col-md-2 advSetupCollumn ${isActiveClass}`}
          key={d.fileName}
        >
          <ManualProfileSequence
            onClick={this.onClickManualProfile}
            id={d.fileName}
            label={d.name.replace(/-/gi, ' ')}
            advSetupNameSelected={this.state.advSetupName}
            active={d.active}
            isPreloaded={d.isPreloaded}
            isFavorite={d.isFavorite}
          />
        </div>
      );
    });

    return showSequence;
  }

  onClickManualProfile = (e) => {
    const fileName = e.currentTarget.id;
    const sequenceFiles = this.state.listSequenceFile;
    const objIndex = sequenceFiles.findIndex((obj) => obj.fileName === fileName);

    sequenceFiles.map((x) => {
      x.active = false;
      return x;
    });

    sequenceFiles[objIndex].active = true;
    this.setState({
      listSequenceFile: sequenceFiles,
    });

    const param = {fileName};
    const passingValue = {};
    Post(APPDATA.API.POST_DETAIL_SEQUENCE, param, this.successGetDetailSequence, passingValue);
  };

  successGetDetailSequence = (response) => {
    const IsPreloaded = response?.data?.IsPreloaded;
    this.setupTopMenuProperties(IsPreloaded, false);
    this.setState({
      selectedSequenceDetail: response.data,
    });
  };

  // eslint-disable-next-line class-methods-use-this
  sequenceNameConverter = (sequence) => {
    switch (sequence) {
      case SEQUENCE_TYPE_ALL_ENUM.PRIME.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME.FE].label;

      case SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.FE].label;

      case SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.FE].label;

      case SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.FE].label;

      case SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.FE].label;

      case SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.FE].label;

      case SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.FE].label;

      case SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.BE:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.FE].label;

      default:
        return SEQUENCE_TYPE[SEQUENCE_TYPE_ALL_ENUM.PRIME.FE].label;
    }
  };

  generateSequenceDetail(sequenceDetail) {
    if (sequenceDetail === null || sequenceDetail === undefined || sequenceDetail === false) return null;
    const showSequence = sequenceDetail.map((d) => {
      const operation = d;
      const repeat = operation.Repeat;
      return (
        <div
          className="sequence-detail-card"
          key={operation.Id}
        >
          <div className="detail-card-cycle text-left sequenceText">
            <span>{this.sequenceNameConverter(operation.Sequence)}</span>
          </div>
          <div className="detail-card-number text-center sequenceText">
            <span>{repeat}</span>
          </div>
          <div className="detail-card-counter text-right sequenceText">
            <span>
              {operation.RepeatType === RUN_TIME_MODE.TIMES.VALUE
                ? RUN_TIME_MODE.TIMES.SIMPLE_NAME
                : operation.RepeatType}
            </span>
          </div>
        </div>
      );
    });

    return showSequence;
  }

  render() {
    const isNoSearchResult = this.state.listSequenceFile !== null && this.state.listSequenceFile.length === 0;

    const style = {
      constraint: {
        fontSize: this.props.fontSize === APPDATA.LARGE_FONT_SIZE ? APPDATA.MEDIUM_FONT_SIZE : this.props.fontSize,
      },
    };
    return (
      <>
        <div style={style.constraint}>
          <div className="mainView col-md-7">
            <div className="row">
              <div className="custom-search-input">
                <div className="input-group col-md-12">
                  <input
                    type="text"
                    onClick={this.actionSearchSequenceFile}
                    className="  search-query form-control"
                    placeholder={
                      this.state.searchManualProfile !== null ? this.state.searchManualProfile : 'Search Profile'
                    }
                  />
                  <span className="input-group-btn">
                    <button
                      className="btn btn-danger"
                      type="button"
                    >
                      <span className=" glyphicon glyphicon-search" />
                    </button>
                  </span>
                </div>
              </div>
            </div>
            <div className={`row explorerView${isNoSearchResult ? ' center ' : ''}`}>
              <ReactCSSTransitionGroup
                transitionName="fade"
                transitionEnter
                transitionLeave={false}
                transitionEnterTimeout={200}
              >
                {isNoSearchResult && (
                  <div className="center">
                    {this.state.searchManualProfile === null && (
                      <div className="text-center">
                        <span className="glyphicon glyphicon-file notFoundIcon" />
                        <h3 className="exploreTitle">No Manual Profile Yet</h3>
                        <p>
                          You can save the manual profile
                          <br />
                          that you have made here
                        </p>
                      </div>
                    )}
                    {this.state.searchManualProfile !== null && (
                      <div className="text-center">
                        <img
                          src={ERROR_FILE_ICON}
                          alt={ERROR_FILE_ICON}
                          className="searchNotFoundIcon"
                        />
                        <h3 className="exploreTitle">Manual Profile Not Found</h3>
                      </div>
                    )}
                  </div>
                )}
                {!isNoSearchResult && this.generateListSequence(this.state.listSequenceFile)}
              </ReactCSSTransitionGroup>
            </div>
          </div>
          <div className="sideView col-md-5">
            <div className="manualProfileDetail text-center">
              {this.state.selectedSequenceDetail !== null && (
                <>
                  <div className="sequenceNameContainer">
                    <div className="col-md-12 sequenceName">
                      <div className="row">
                        <div className="col-md-8 text-left">
                          <div className="row">
                            <span className="sequenceTitle">{this.state.selectedSequenceDetail.FileName}</span>
                          </div>
                          <div className="row">
                            <span className="sequenceDate">{this.state.selectedSequenceDetail.DateTime}</span>
                          </div>
                        </div>
                        <div className="sequenceButton">
                          {!this.state.selectedSequenceDetail?.IsPreloaded && (
                            <>
                              <div className="sequenceActionButton">
                                <FmlxButton
                                  onlyIcon
                                  size={FmlxButton.Size.EXTRA_LARGE}
                                  variant={FmlxButton.Variant.CONTAIN}
                                  type={FmlxButton.Type.PRIMARY}
                                  onClick={() => this.onClickFavoriteSequence(this.state.selectedSequenceDetail)}
                                  icon={
                                    <FmlxIcon
                                      name={this.state.selectedSequenceDetail.IsFavorite ? 'StarOff' : 'StartFilled'}
                                    />
                                  }
                                />
                              </div>
                              <div className="sequenceActionButton">
                                <FmlxButton
                                  onlyIcon
                                  icon={<FmlxIcon name="PencilBorder" />}
                                  size={FmlxButton.Size.EXTRA_LARGE}
                                  onClick={this.actionRenameSequenceFile}
                                  variant={FmlxButton.Variant.CONTAIN}
                                  type={FmlxButton.Type.PRIMARY}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row sequenceContainer">
                    {this.generateSequenceDetail(this.state.selectedSequenceDetail.Operations)}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <PopUpWizard
          data={DataHelp}
          fontSize={this.props.fontSize}
          popUpWizardVisible={this.state.isHelpModeEnable}
          onClose={this.onClosePopUpWizard}
        />
      </>
    );
  }
}

export default ManualProfileExplorer;
